import { useAuthStore } from "@stores/auth/authStore";

/** Same shape as tenant `useAuth` for shared patterns (e.g. notification stream). */
export const useAuth = () => {
    const user = useAuthStore((s) => s.user);
    const token = useAuthStore((s) => s.token);
    const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
    const clearAuth = useAuthStore((s) => s.clearAuth);
    return { user, token, isAuthenticated, clearAuth };
};
